module.exports = __webpack_public_path__ + "static/img/store_wupin_yiny.558007b2.svg";